// extracted by mini-css-extract-plugin
export var card = "RecipeCard-module--card--1Ljdm";
export var title = "RecipeCard-module--title--30M_a";
export var serves = "RecipeCard-module--serves--1Bwsy";
export var ingredients = "RecipeCard-module--ingredients--Zw0nS";
export var steps = "RecipeCard-module--steps--2Riz2";